import { get } from 'lodash';
import axios, { baseUrl } from './axios';

export default {
  updateAppointmentNode: async options => {
    const token = get(options, 'token');
    let transformRequest = {};
    if (token) {
      transformRequest = {
        transformRequest: [
          (data, headers) => {
            headers.common.Authorization = `Bearer ${options.token}`;
            return JSON.stringify(data);
          },
        ],
      };
    }

    const result = await axios.put(
      `${baseUrl}/scheduler/pob/appointment/${options.appointmentId}/notes`,
      options.data,
      transformRequest,
    );
    return result.data;
  },
};
